import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ServiceService } from '../service.service';
import { FormControl,FormGroup,Validators,FormBuilder } from '@angular/forms';
import { AuthServiceService } from '../Auth/auth-service.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
msg1=""
msg2=""
msg3=""
output: any=[];
showPassword : boolean = false;
returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin/dashboard';
//postUrl='http://192.241.151.66:5000/login';
constructor(private router: Router,private logServices:ServiceService ,private route : ActivatedRoute , private authService : AuthServiceService) { }
data={
  username:"",
  password:"",
  user_type:"Admin"||"User"
}

togglePasswordVisibility(){
  this.showPassword = !this.showPassword;
}

valuechange1(newValue1: any) {
  this.data.username=newValue1
  this.msg1=""
  this.msg3=""
}
valuechange2(newValue2: any) {
  this.data.password=newValue2
  this.msg2=""
  this.msg3=""
}
btnClick(){
 if(this.data.username=="" && this.data.password=="")
 {
  this.msg1="Invalid user name";
  this.msg2="Invalid password";
  return;
 }
 if(this.data.password=="")
 {
  this.msg2="Invalid password"
  return;
 }
 if(this.data.username==""){
  this.msg1="Invalid user name";
  return;
 }
  this.logServices.Login(this.data).subscribe((res)=>{
        
    this.output=res.data
      const token = res?.uidToken || ''
  // Check if the token is empty
  // if (!token) {
  //   this.msg3 = "Failed to login. Please try again.";  //uncomment once token is live deployed
  //   return;
  // }
/* check admin or user*/
if (res.success == "true") {
  //----auth guard services----------
  this.authService.login(token,this.output[0]?.user_type,this.output[0]?.user_details[0]?.employee_name,this.output[0]?.user_id,this.output[0]?.user_details[0]?.department_id,this.output[0]?.user_details[0]?.department,this.output[0]?.head_factory_department?.factory_department_id,this.output[0]?.head_factory_department?.factory_department_name);
  this.router.navigateByUrl(this.returnUrl);
  // debugger
} else {
  this.msg3 = "Wrong user name or password";
}
  /*
  else
  {
    this.router.navigate(['/home']);
  }
 */

  })
   
};

  ngOnInit(): void {
  }

}
